DJ.addBehavior('counters', '.js-counters', {
  attach: function(context, settings, behavior) {
    // CONFIG
    var visibilityIds = ['.js-counters']; //must be an array, could have only one element
    var counterClass = '.counter';
    var defaultSpeed = 3000; //default value

    // END CONFIG

    //init if it becomes visible by scrolling
    jQuery(window).on('scroll', function () {
      getVisibilityStatus();
    });

    //init if it's visible by page loading
    getVisibilityStatus();

    function getVisibilityStatus() {
      elValFromTop = [];
      var windowHeight = jQuery(window).height(),
        windowScrollValFromTop = jQuery(this).scrollTop();

      visibilityIds.forEach(function (item, index) { //Call each class
        try { //avoid error if class not exist
          elValFromTop[index] = Math.ceil(jQuery(item).offset().top);
        } catch (err) {
          return;
        }
        // if the sum of the window height and scroll distance from the top is greater than the target element's distance from the top,
        //it should be in view and the event should fire, otherwise reverse any previously applied methods
        if ((windowHeight + windowScrollValFromTop) > elValFromTop[index]) {
          counter_init(item);
        }
      });
    }

    function counter_init(groupId) {
      var num, speed, direction, index = 0;
      jQuery(counterClass).each(function () {
        num = jQuery(this).attr('data-TargetNum');
        speed = jQuery(this).attr('data-Speed');
        direction = jQuery(this).attr('data-Direction');
        easing = jQuery(this).attr('data-Easing');
        if (speed == undefined) speed = defaultSpeed;
        jQuery(this).addClass('c_' + index); //add a class to recognize each counter
        doCount(num, index, speed, groupId, direction, easing);
        index++;
      });
    }

    function doCount(num, index, speed, groupClass, direction, easing) {
      var className = groupClass + ' ' + counterClass + '.' + 'c_' + index;
      if(easing == undefined) easing = "swing";

      function gap(strval) {
        if (typeof strval === "number") {
          return String(strval).replace(/\d(?=(?:\d{3})+\b)/g, "$&" +'&nbsp;');
        }
        return strval;
      }

      jQuery(className).animate({
        num
      }, {
        duration: +speed,
        easing: easing,
        step: function (now) {
          if (direction == 'reverse') {
            jQuery(this).text(num - Math.floor(now));
          } else {
            jQuery(this).html(gap(Math.floor(now)));
          }
        },
        complete: doCount
      });
    }
  },

  detach: function(context, settings) {}
});
